import { useEffect } from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";

import { useImageSelector } from "./ImageSelector";

// this component uses ImageSelector to provide an image

const useStyles = createUseStyles({
  button: {
    display: "flex",
    width: "100%",
    height: 200,
    borderRadius: 10,
    backgroundColor: "#444",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    position: "relative",
    marginTop: 5,
  },
  name: {
    color: "white",
    margin: 0,
    position: "absolute",
    right: 10,
    bottom: 5,
    textShadow: "0 0 1px #000000, 0 0 1px #000000, 0 0 1px #000000",
  },
  message: {
    color: "white",
    margin: 0,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
});

const ImageSelectorButton = ({
  value,
  onChange,
  images,
  className,
  keepState,
  filter,
}) => {
  const [imageId, getImage, setImage] = useImageSelector(value, filter);
  const image = images[imageId];
  const classes = useStyles({ image });

  useEffect(() => {
    if (imageId !== value) {
      onChange(image);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, imageId]);

  // for timeline nodes, we don't want it to keep it's internal state
  useEffect(() => {
    if (!keepState) {
      if (value === null) setImage(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, imageId]);

  return (
    <div
      className={clsx(classes.button, className)}
      style={image ? { backgroundImage: `url("${image.urls.low}")` } : {}}
      onClick={() => getImage(filter)}
    >
      {image ? (
        <p className={classes.name}>{image.name}</p>
      ) : (
        <p className={classes.message}>Select an image</p>
      )}
    </div>
  );
};

export default ImageSelectorButton;
